package com.havn.app.core.designsystem

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.SizeTransform
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.togetherWith
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
fun <T> HavnPushNavigation(
    targetState: T,
    depthFor: (T) -> Int,
    modifier: Modifier = Modifier,
    content: @Composable (T) -> Unit
) {
    AnimatedContent(
        targetState = targetState,
        modifier = modifier,
        transitionSpec = {
            val pushing = depthFor(targetState) > depthFor(initialState)
            val durationMillis = 320
            val incoming = if (pushing) {
                slideInHorizontally(
                    animationSpec = tween(durationMillis),
                    initialOffsetX = { fullWidth -> fullWidth }
                )
            } else {
                slideInHorizontally(
                    animationSpec = tween(durationMillis),
                    initialOffsetX = { fullWidth -> -fullWidth / 3 }
                )
            } + fadeIn(animationSpec = tween(durationMillis))

            val outgoing = if (pushing) {
                slideOutHorizontally(
                    animationSpec = tween(durationMillis),
                    targetOffsetX = { fullWidth -> -fullWidth / 3 }
                )
            } else {
                slideOutHorizontally(
                    animationSpec = tween(durationMillis),
                    targetOffsetX = { fullWidth -> fullWidth }
                )
            } + fadeOut(animationSpec = tween(durationMillis))

            incoming togetherWith outgoing using SizeTransform(clip = false)
        },
        label = "HAVN navigation push"
    ) { visibleState ->
        content(visibleState)
    }
}
